<div class="content">
  <Info
    title="Persoonlijke informatie"
    details={window.zoekModalOptions.persoonlijke_informatie_text}
    imgSrc={window.zoekModalOptions.persoonlijke_informatie_image} />
  <div class="inputs">
    <label for="input-1">Voornaam{name ? '' : '*'}</label>
    <input
      id="input-1"
      type="text"
      placeholder="Voornaam"
      name="name"
      bind:value={name} />
    <label for="input-2">Achternaam{surname ? '' : '*'}</label>
    <input
      id="input-2"
      type="text"
      placeholder="Achternaam"
      name="surname"
      bind:value={surname} />
    <label for="input-3">Emailadres{email ? '' : '*'}</label>
    <input
      id="input-3"
      type="text"
      placeholder="Emailadres"
      name="email"
      bind:value={email} />
    <label for="input-4">Telefoonnummer</label>
    <input
      id="input-4"
      type="text"
      placeholder="Telefoonnummer"
      name="phone"
      bind:value={phone} />
    <label for="input-5">Bericht</label>
    <textarea
      id="input-5"
      type="text"
      placeholder=""
      name="description"
      bind:value={description} />
  </div>
</div>

<script>
  import Info from "./Info.svelte";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  let name;
  let surname;
  let email;
  let phone;
  let description;
  $: complete = name && surname && email;
  $: dispatch("complete", complete);
</script>

<style lang="postcss">
  .content {
    @apply relative mx-5 pt-8 leading-7;
  }

  .inputs {
    @apply p-12 pt-16 border border-t-0;
  }

  label {
    @apply inline-block;
  }

  input ~ label {
    @apply mt-8;
  }

  input,
  textarea {
    background: #ebebeb;
    color: #202020;
    @apply w-full mt-3 px-5 py-3 leading-7;
  }

  input::-webkit-input-placeholder,
  input::placeholder {
    color: #c1c3ca;
  }

  @screen sm {
    .content {
      @apply mx-12;
    }

    .inputs {
      @apply p-16 mr-16 flex flex-col;
    }

    input,
    textarea {
      @apply w-3/4;
    }
  }

  @screen md {
    .content {
      @apply flex items-start;
    }

    .content :global(.info) {
      @apply bg-white;
    }

    .inputs {
      @apply mt-10 -ml-16 pl-32 border-t w-full mr-20;
    }

    input,
    textarea {
      @apply w-full max-w-sm;
    }
  }
</style>
